import actions from "./actions"
import { mutations } from "./mutations"
import getters from "./getters"
import { QuoteMode, QuoteState } from "@/models/QuoteState"

export default {
	namespaced: true,
	state: (): QuoteState => {
		return {
			jobImages: [],
			propertyImages: [],
			attributes: [],
			quoteDevices: [],
			mode: QuoteMode.SERVICES,
			quoteImages: [],
			in_edit_mode: true,
			checklist: {
				pre: [],
				post: []
			},
			computeData: null
		}
	},
	mutations,
	actions,
	getters
}
